// @flow

import React from 'react'
import { roomName } from 'frontend_core/dist/helpers/format'
import { isMobile } from 'common/screen'
import ScrollControlView from 'components/atoms/ScrollControlView'
import CoverPhotoSlideShow from 'components/organisms/room/CoverPhotoSlideShow'
import RoomPagePresenter from 'containers/pages/RoomPage/RoomPagePresenter'
import type { Room } from 'types/room'

type PropTypes = {
  data: {
    room: Room,
  },
  ui: {
    isShowingModal: boolean,
    currentDisplayingIndex: number,
    fadeAnimationType: number,
  },
  usecase: {
    displayAtSlideShow: Function,
    dismissSlideShow: Function,
    setSlideCurrentIndex: Function,
  },
}

export default class CoverPhotoSlideShowContainer extends React.Component<*> {
  constructor(props: PropTypes) {
    super(props)
    this.roomPagePresenter = new RoomPagePresenter(props.data.room)
  }

  componentWillReceiveProps(nextProps: PropTypes) {
    if (nextProps.ui.isShowingModal) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
  }

  roomPagePresenter: RoomPagePresenter
  props: PropTypes

  render() {
    const { ui, usecase } = this.props
    const { room } = this.props.data
    const roomThumbnails = this.roomPagePresenter.getThumbnails()

    return (
      <ScrollControlView isLock={ui.isShowingModal && isMobile()}>
        <CoverPhotoSlideShow
          thumbnails={roomThumbnails}
          isShowingModal={ui.isShowingModal}
          currentDisplayingIndex={ui.currentDisplayingIndex}
          onDisplayAt={usecase.displayAtSlideShow}
          onSlide={usecase.setSlideCurrentIndex}
          onClickDismissModal={usecase.dismissSlideShow}
        />
      </ScrollControlView>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/organisms/room/CoverPhotoSlideShow/index.jsx